import { render, staticRenderFns } from "./AllowedPrincipals.vue?vue&type=template&id=61951038&"
import script from "./AllowedPrincipals.vue?vue&type=script&lang=js&"
export * from "./AllowedPrincipals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports